import { Component, Input, ViewChild } from "@angular/core";
import { CopyInputComponent } from "./copy-input.component";
import { InlineAlertComponent } from "../inline-alert/inline-alert.component";

@Component({
  selector: "hbr-push-image-button",
  template: `<div>
    <clr-dropdown>
        <button class="btn btn-link btn-font" clrDropdownToggle (click)="onclick()">
            {{ 'PUSH_IMAGE.TITLE' | translate | uppercase}}
            <clr-icon shape="caret down"></clr-icon>
        </button>
        <clr-dropdown-menu *clrIfOpen [clrPosition]="'bottom-right'" style="min-width:500px;">
            <div class="commands-container">
                <section>
                    <span><h5 class="h5-override">{{ 'PUSH_IMAGE.TITLE' | translate }}</h5></span>
                    <span>
                      <clr-tooltip>
                        <clr-icon  clrTooltipTrigger shape="info-circle" class="info-tips-icon" size="24"></clr-icon>
                        <clr-tooltip-content [clrPosition]="'top-right'" [clrSize]="'md'" *clrIfOpen>
                            {{ 'PUSH_IMAGE.TOOLTIP' | translate }}
                        </clr-tooltip-content>
                      </clr-tooltip>
                    </span>
                </section>
                <section>
                  <hbr-inline-alert #copyAlert></hbr-inline-alert>
                </section>
                <section>
                    <article class="commands-section">
                        <hbr-copy-input #tagCopy (onCopyError)="onCpError($event)" inputSize="50" headerTitle="{{ 'PUSH_IMAGE.TAG_COMMAND' | translate }}" defaultValue="{{tagCommand}}"></hbr-copy-input>
                    </article>
                    <article class="commands-section">
                        <hbr-copy-input #pushCopy (onCopyError)="onCpError($event)" inputSize="50" headerTitle="{{ 'PUSH_IMAGE.PUSH_COMMAND' | translate }}" defaultValue="{{pushCommand}}"></hbr-copy-input>
                    </article>
                </section>
            </div>
        </clr-dropdown-menu>
    </clr-dropdown>
</div>`,
  styles: [`.commands-container{min-width:360px;max-width:720px;padding-left:24px}.h5-override{display:inline-block!important;margin-top:0!important;margin-bottom:12px}.commands-section{margin-top:12px;margin-bottom:24px}.info-tips-icon{color:grey}.info-tips-icon:hover{color:#007cbb;cursor:pointer}.command-title{font-size:14px;padding-left:6px}.command-input{font-size:14px;font-weight:500}:host>>>.dropdown-menu{min-width:360px;max-width:720px}.btn-font{font-size:14px!important}.hide{display:none}`],

  providers: []
})
export class PushImageButtonComponent {
  @Input() registryUrl: string = "unknown";
  @Input() projectName: string = "unknown";

  @ViewChild("tagCopy") tagCopyInput: CopyInputComponent;
  @ViewChild("pushCopy") pushCopyInput: CopyInputComponent;
  @ViewChild("copyAlert") copyAlert: InlineAlertComponent;

  public get tagCommand(): string {
    return `docker tag SOURCE_IMAGE[:TAG] ${this.registryUrl}/${
      this.projectName
    }/IMAGE[:TAG]`;
  }

  public get pushCommand(): string {
    return `docker push ${this.registryUrl}/${this.projectName}/IMAGE[:TAG]`;
  }

  onclick(): void {
    if (this.tagCopyInput) {
      this.tagCopyInput.reset();
    }

    if (this.pushCopyInput) {
      this.pushCopyInput.reset();
    }

    if (this.copyAlert) {
      this.copyAlert.close();
    }
  }

  onCpError($event: any): void {
    if (this.copyAlert) {
      this.copyAlert.showInlineError("PUSH_IMAGE.COPY_ERROR");
    }
  }
}
